import React from 'react';

import {GridViewSelector} from './GridViewSelector.jsx';
import {ListViewSelector} from './ListViewSelector.jsx';

var ViewSelector = React.createClass({
  getInitialState: function(){
    return { windowWidth: window.innerWidth}  //  set intial state of list view and grid view. by default grid view is true and list view is false
  },
  componentDidMount : function() {
      window.addEventListener('resize', this.handleResize); // for changing list view to grid view
  },
  componentWillUnmount: function() {
      window.removeEventListener('resize', this.handleResize); // for changing the list view to grid view
  },
  handleResize: function(e){
    this.setState({windowWidth: window.innerWidth}); // for changing list view to grid view
    if(this.state.windowWidth <= 1004)
    {
      this.props.onInputgrid(true); // set property of grid view(true or false) to Application.jsx
      this.props.onInputlist(false);
    }
  },
  handleInputGrid:function(value){
    this.props.onInputgrid(value); // set property of grid view(true or false) to Application.jsx
  },
  handleInputList: function(value){
    this.props.onInputlist(value);  // set property of list view(true or false) to Application.jsx
  },
  render: function(){
    return(
         <div className="content__col content__col--second">
          <div className="views">
            <GridViewSelector onInput = {this.handleInputGrid} 
                              gridview = {this.props.gridview} />
            <ListViewSelector onInput = {this.handleInputList} 
                              listview = {this.props.listview} />
          </div>
        </div>
      );
  }
});

export {ViewSelector};


/** WEBPACK FOOTER **
 ** ./html/components/ViewSelector.jsx
 **/